export default __webpack_public_path__ + "static/media/cover.2f8293e8.png";